import { useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, TrendingDown, Flag, MessageCircle, Users, ChevronDown, ArrowRight } from "lucide-react";
import { read } from "@/components/app/Prompts";

const ICON = { conflict: AlertTriangle, regression: TrendingDown, journey: Flag, prompt: MessageCircle, engage: Users };
const TONE = { conflict: "bg-warning-50 text-warning-900", regression: "bg-danger-50 text-danger-900", journey: "bg-accent-50 text-accent-700", prompt: "bg-muted text-subtle", engage: "bg-ink text-on-dark" };
const SHOW = 5;

// Top "what needs you" item per active change — same ranking as the change page feed, prompts honour the same localStorage dismissals.
export default function NeedsYou({ rows }) {
  const [all, setAll] = useState(false);
  const items = (rows || []).map((r) => {
    const dismissed = read(r.change_id);
    const top = r.items.find((i) => i.kind !== "prompt" || !dismissed.includes(i.key));
    return top ? { ...r, top } : null;
  }).filter(Boolean);
  if (items.length === 0) return null;
  const shown = all ? items : items.slice(0, SHOW);
  return (
    <section className="pp-card p-6 mt-6" data-testid="dashboard-needs-you" aria-labelledby="needs-you-heading">
      <div className="flex items-center justify-between gap-3">
        <h2 id="needs-you-heading" className="font-head text-lg font-extrabold">What needs you <span className="text-sm font-semibold text-muted-foreground">· across {items.length} active change{items.length !== 1 ? "s" : ""}</span></h2>
        {items.length > SHOW && <button data-testid="dashboard-needs-you-toggle" aria-expanded={all} onClick={() => setAll(!all)} className="inline-flex items-center gap-1 text-xs font-bold text-subtle hover:text-foreground">{all ? "Show fewer" : `Show ${items.length - SHOW} more`} <ChevronDown size={13} className={`transition-transform ${all ? "rotate-180" : ""}`} /></button>}
      </div>
      <ul className="mt-3 divide-y divide-border-soft">
        {shown.map((r) => { const I = ICON[r.top.kind]; return (
          <li key={r.change_id}>
            <Link to={`/app/changes/${r.change_id}?tab=${r.top.tab}`} data-testid={`needs-you-${r.ref}`} className="flex items-start gap-3 py-3 group rounded-lg -mx-2 px-2 hover:bg-muted transition-colors">
              <span className={`mt-0.5 w-7 h-7 rounded-full flex items-center justify-center shrink-0 ${TONE[r.top.kind]}`} aria-hidden="true"><I size={14} /></span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-bold text-foreground">{r.top.title}</span>
                <span className="block text-xs text-subtle mt-0.5 line-clamp-1">{r.top.detail}</span>
                <span className="block text-[11px] font-mono text-muted-foreground mt-1">{r.ref} · {r.title}{r.items.length > 1 ? ` · +${r.items.length - 1} more on the change` : ""}</span>
              </span>
              <ArrowRight size={14} className="mt-1 text-muted-foreground group-hover:text-foreground shrink-0" aria-hidden="true" />
            </Link>
          </li>); })}
      </ul>
    </section>
  );
}
